import { isSameDay } from 'date-fns'
import { observer } from 'mobx-react'
import { useMemo } from 'react'

import type { ClockType } from '@/component/molecules/TimeBox/_hook'
import { clock, lastDayClock, useTimeBox } from '@/component/molecules/TimeBox/_hook'
import type { Banner } from '@/dto'
import type { StyleProps } from '@/types'

import S from './HeaderUtil.style'

type Props = { banner: Banner; onClick: (banner: Banner) => void }

const TooltipBanner = ({ banner, onClick }: Props) => {
  const clockProps = useMemo(() => {
    clock.timeOne.color = banner.tooltipTextColor
    clock.timeTwo.color = banner.tooltipTextColor
    clock.timeThree.color = banner.tooltipTextColor
    lastDayClock.timeOne.color = banner.tooltipTextColor
    lastDayClock.timeTwo.color = banner.tooltipTextColor
    lastDayClock.timeThree.color = banner.tooltipTextColor
    return { clockType: clock, lastDayClockType: lastDayClock }
  }, [banner])

  return (
    <>
      <div css={S.tooltipBanner(banner.tooltipImageUrl)}>
        <button className="apply-button" onClick={() => onClick(banner)}>
          &nbsp;
        </button>
        <div className="clock-area">
          {banner.isTimerTextVisible && (
            <TextClock start={new Date()} end={banner.expiredAt} {...clockProps} />
          )}
        </div>
      </div>
    </>
  )
}

export type TextClockProps = {
  start: Date
  end: Date
  clockType: ClockType
  lastDayClockType: ClockType
}

const TextClock = observer(({ start, end, clockType, lastDayClockType }: TextClockProps) => {
  const isLastDay = useMemo(() => isSameDay(start, end), [start, end])
  const clock = isLastDay ? lastDayClockType : clockType

  return (
    <div css={S.textClock}>
      <TextClockItem {...clock.timeOne} end={end} className="clock-item" />
      <TextClockItem {...clock.timeTwo} end={end} className="clock-item" />
      <TextClockItem {...clock.timeThree} end={end} className="clock-item" />
    </div>
  )
})

export type TextClockItemProps = {
  color: ValueOf<ClockType>['color']
  end: TextClockProps['end']
  formular: ValueOf<ClockType>['formular']
  kor: ValueOf<ClockType>['kor']
} & StyleProps

export const TextClockItem = observer(
  ({ color, end, kor, formular, style, ...props }: TextClockItemProps) => {
    const time = useTimeBox(end, formular)

    if (isNaN(Number(time))) return null

    return (
      <div style={{ color, ...style }} {...props}>
        <time>{time ?? '-'}</time>
        <p>{kor}</p>
      </div>
    )
  },
)

export default observer(TooltipBanner)
